import React from 'react';

import './UserView.scss';
import { UserHeader } from 'components/Headers/UserHeader/UserHeader';
import { useViewVM } from '../useViewVM';
export type UserViewProps = {
    render: React.ReactNode;
    headerTitle?: string;
};

export const UserView: React.FC<UserViewProps> = ({ render, headerTitle = '' }) => {
    const { } = useViewVM({ render });

    return (
        <>
            <UserHeader title={headerTitle} />
            <div className="renderer user">{render}</div>
        </>
    );
};
